/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 지역별 노출도 탭
 * 버전 : 1.0
 * 파일명 : Legion_Expose.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 
 * 수정 : 2026-01-30, 강동형 : 가드 추가
 * ================================================================*/

import { styled } from '@mui/material'
import { useEffect, useState } from 'react'
import DateRangePickerLegionExpose from './DateRangePickerLegionExpose'
import { SmallRoundToggleButton } from '../common/CommonStyled'
import Legion_ExposeTable from './Legion_ExposeTable'
import { useAdAchiveStore } from 'src/stores/AdAchiveStore'
import { LoadLegionExpose } from './useLoadLegionExpose'

const TapWrapper = styled('div')(({theme})=>({
  display:'flex',
  flexDirection:'column',

  position:'relative',
  height:'calc(100vh - 202px)',
  padding:'20px',
}))

const ToogleWrapper = styled('div')(({theme})=>({
    display:'flex',
    justifyContent:'flex-start',
    alignItems:'center',
    gap:'10px',
    marginTop:'20.5px',
    marginBottom:'10px'
}))


const Legion_Expose = () => {
  const today = new Date();
  const prevMonth = new Date(today); // 오늘 날짜 복사
  prevMonth.setMonth(prevMonth.getMonth() - 1);
  const [periodOption,setPeriodOption] = useState<string | number>('1개월')
  const data = useAdAchiveStore((state)=>state.legionExposeData)
  const [start_date,setStart_date] = useState<string| null>(prevMonth.toISOString().slice(0, 10))
  const [end_date,setEnd_date] = useState<string| null>(today.toISOString().slice(0, 10))
  const setField = useAdAchiveStore((state)=>state.setField)


  const fetchData = async () => {
    const result = await LoadLegionExpose(start_date,end_date);
    setField('legionExposeData',result)
  };

  // useEffect(()=>{
  //     if(data.length === 0){
  //       fetchData()
  //     }
  //   },[])

  useEffect(()=>{
    const startDate = new Date(today); // today 복사
    if (periodOption === ''){
      return
    }
    if (periodOption === '1개월') {
      startDate.setMonth(today.getMonth() - 1);
    } else if (periodOption === '3개월') {
      startDate.setMonth(today.getMonth() - 3);
    } else if (periodOption === '6개월') {
      startDate.setMonth(today.getMonth() - 6);
    } else if (periodOption === '1년') {
      startDate.setFullYear(today.getFullYear() - 1);
    }
    setStart_date(startDate.toISOString().slice(0, 10))
    setEnd_date(today.toISOString().slice(0, 10))
  },[periodOption])

  useEffect(()=>{
    fetchData()
  },[start_date,end_date])
  return (
      <TapWrapper>
          <DateRangePickerLegionExpose start_date={start_date} end_date={end_date} setStart_date={setStart_date} setEnd_date={setEnd_date} setPeriodOption={setPeriodOption}/>
          <ToogleWrapper>
              <SmallRoundToggleButton $isSelected={periodOption==='1개월'} onClick={()=>setPeriodOption('1개월')}>1개월</SmallRoundToggleButton>
              <SmallRoundToggleButton $isSelected={periodOption==='3개월'} onClick={()=>setPeriodOption('3개월')}>3개월</SmallRoundToggleButton>
              <SmallRoundToggleButton $isSelected={periodOption==='6개월'} onClick={()=>setPeriodOption('6개월')}>6개월</SmallRoundToggleButton>
              <SmallRoundToggleButton $isSelected={periodOption==='1년'} onClick={()=>setPeriodOption('1년')}>1년</SmallRoundToggleButton>
          </ToogleWrapper>
          <Legion_ExposeTable propsData={data ?? []}/>
      </TapWrapper>
  )
}

export default Legion_Expose